import React, { PureComponent, ReactNode } from 'react'
import './NeedHelp.scss'
import { Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { TFunction } from 'i18next'

interface IProps {
  content?: string
  style?: React.CSSProperties
  t: TFunction
}
class NeedHelp extends PureComponent<IProps> {
  render(): ReactNode {
    return (
      <LinkContainer to="/faq">
        <div className="need-help d-flex align-items-center" style={this.props.style}>
          <i className="la la-question-circle icon"></i>
          <span className="flex-grow-1">
            {
              this.props.content ? this.props.content : this.props.t("home.public.needHelpDefault")
            }
          </span>
          <Button className="btn-sm">{this.props.t("home.public.needHelpOpen")}<i className="la la-book"></i></Button>
        </div>
      </LinkContainer>
    )
  }
}

export default NeedHelp
